// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* --bodyFontFamily: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif !important; */
  --bodyFontFamily: "JesayaBk-Regular" !important;

  --bodyTextColor: #000000;
  --primaryColor: #000000;
  --secondaryColor: #818093;
  --successColor: #00B69B;
  --infoColor: #2DB6F5;
  --warningColor: #FFBC2B;
  --dangerColor: rgb(238, 54, 140);
  --darkColor: #260944;
  --headingColor: #260944;
  --whiteColor: #ffffff;
  --fontSize: 15px;
  --transition: all ease .5s;
  --box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.05);
  /* --gradientColor1:#e25d65;
  --gradientColor2:#9d58a3;
  --gradientColorLighter1:rgba(226, 93, 102, 0.88);
  --gradientColorLighter2:rgba(157, 88, 163, 0.8);
  --gradientColorLightest1:rgba(226, 93, 102, 0.48);
  --gradientColorLightest2:rgba(157, 88, 163, 0.4); */
  --gradientColor1: #DC5F00;
  --gradientColor2:#DC5F00;
  --gradientColorLighter1:#DC5F00;
  --gradientColorLighter2:#DC5F00;
  --gradientColorLightest1:#DC5F00;
  --gradientColorLightest2:#DC5F00;
  /* --gradientColor2:   #5c5858;
  --gradientColor1: #232023;
  --gradientColorLighter2:#5c5858;
  --gradientColorLighter1:#232023;
  --gradientColorLightest2:#5c5858;
  --gradientColorLightest1:#232023; */
}

html, body {
  background-color: #F5F5F5 !important;
  font-family: var(--bodyFontFamily) !important;
}

h1, h2, h3, h4, h5, h6 {
  color: var(--headingColor);
}

::-moz-placeholder {
  font-family: var(--bodyFontFamily) !important;
}

/* div, label, a, p, tspan, span, li, table, tbody, tfoot, thead, th, td, canvas, button, input, ::placeholder, abbr, address, blockquote, caption, cite, code, dd, dl, mark, option, pre, select, time, del {
  font-family: var(--bodyFontFamily) !important;
} */
div, label, a, p, tspan, span, li, table, tbody, tfoot, thead, th, td, canvas, button, input, ::placeholder, abbr, address, blockquote, caption, cite, code, dd, dl, mark, option, pre, select, time, del {
  font-family:"JesayaBk-Regular"  !important;
}
img {
  max-width: 100%;
}

.text-decoration-none {
  text-decoration: none;
}

.borRadius100 {
  border-radius: 100%;
}

.borderRadius10 {
  border-radius: 10px;
}

/* Color */
.primaryColor {
  color: var(--primaryColor) !important;
}

.secondaryColor {
  color: var(--secondaryColor) !important;
}

.successColor {
  color: var(--successColor) !important;
}

.infoColor {
  color: var(--infoColor) !important;
}

.warningColor {
  color: var(--warningColor) !important;
}

.dangerColor {
  color: var(--dangerColor) !important;
}

.darkColor {
  color: var(--darkColor) !important;
}

/* BG Color */
.primaryBgColor {
  background-color: var(--primaryColor) !important;
}

.secondaryBgColor {
  background-color: var(--secondaryColor) !important;
}

.successBgColor {
  background-color: var(--successColor) !important;
}

.infoBgColor {
  background-color: var(--infoColor) !important;
}

.warningBgColor {
  background-color: var(--warningColor) !important;
}

.dangerBgColor {
  background-color: var(--dangerColor) !important;
}

.darkBgColor {
  background-color: var(--darkColor) !important;
}

/* Badge custom style */
.primaryBadge {
  background: rgba(117, 127, 239, 0.1);
  border-radius: 4px;
  color: var(--primaryColor) !important;
  padding: 5px 13px;
  display: inline-block;
}

.secondaryBadge {
  background: rgba(117, 127, 239, 0.1);
  border-radius: 4px;
  color: var(--secondaryColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.successBadge {
  background: rgba(0, 182, 155, 0.1);
  border-radius: 4px;
  color: var(--successColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.SuccessBadge {
  background: rgba(0, 182, 155, 0.1);
  border-radius: 4px;
  color: var(--successColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.ActiveBadge {
  background: rgba(0, 182, 155, 0.1);
  border-radius: 4px;
  color: var(--successColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.ApprovedBadge,.CreateBadge{
  background: rgba(0, 182, 155, 0.1);
  border-radius: 4px;
  color: var(--successColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.PendingBadge,.UpdateBadge , .ExpiringSoonBadge {
  background: rgba(235, 97, 6, 0.1);
  border-radius: 4px;
  color: var(--warningColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.InactiveBadge {
  background: rgba(238, 54, 140, 0.1);
  border-radius: 4px;
  color: var(--dangerColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.FailedBadge {
  background:  rgba(238, 54, 140, 0.1);
  border-radius: 4px;
  color: var(--dangerColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.ExpiredBadge,.RejectedBadge,.DeleteBadge {
  background:  rgba(238, 54, 140, 0.1);
  border-radius: 4px;
  color: var(--dangerColor) !important;
  padding: 5px 13px;
  display: inline-block;
}

.infoBadge {
  background: rgba(117, 127, 239, 0.1);
  border-radius: 4px;
  color: var(--infoColor) !important;
  padding: 5px 13px;
  display: inline-block;
}

.dangerBadge {
  background: rgba(238, 54, 140, 0.1);
  border-radius: 4px;
  color: var(--dangerColor) !important;
  padding: 5px 13px;
  display: inline-block;
}
.ActorBadge {
  background: rgb(123, 198, 204,.1);
  border-radius: 4px;
  color: #7BC6CC !important;
  padding: 5px 13px;
  display: inline-block;
}
.ActressBadge {
  background:rgb(190, 147, 197,.1);
  border-radius: 4px;
  color: #BE93C5 !important;
  padding: 5px 13px;
  display: inline-block;
}
.DirectorBadge {
  background:rgb(176, 218, 185,.1);
  border-radius: 4px;
  color: #B0DAB9 !important;
  padding: 5px 13px;
  display: inline-block;
}
.ProducerBadge {
  background:  rgb(255, 195, 113,.1);
  border-radius: 4px;
  color:  #FFC371 !important;
  padding: 5px 13px;
  display: inline-block;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

.ml-auto {
  margin-left: auto !important;
}

.ml-1 {
  margin-left: 8px !important;
}

.ml-2 {
  margin-left: 16px !important;
}

.ml-3 {
  margin-left: 24px !important;
}

.ml-4 {
  margin-left: 32px !important;
}

.ml-5 {
  margin-left: 40px !important;
}

.mr-1 {
  margin-right: 8px !important;
}

.mr-2 {
  margin-right: 16px !important;
}

.mr-3 {
  margin-right: 24px !important;
}

.mr-4 {
  margin-right: 32px !important;
}

.mr-5 {
  margin-right: 40px !important;
}

.ml-5px {
  margin-left: 5px !important;
}

.ml-6px {
  margin-left: 6px !important;
}

.ml-7px {
  margin-left: 7px !important;
}

.ml-8px {
  margin-left: 8px !important;
}

.ml-9px {
  margin-left: 9px !important;
}

.ml-10px {
  margin-left: 10px !important;
}

.ml-11px {
  margin-left: 11px !important;
}

.ml-12px {
  margin-left: 12px !important;
}

.ml-13px {
  margin-left: 13px !important;
}

.ml-14px {
  margin-left: 14px !important;
}

.ml-15px {
  margin-left: 15px !important;
}

.ml-16px {
  margin-left: 16px !important;
}

.ml-17px {
  margin-left: 17px !important;
}

.ml-18px {
  margin-left: 18px !important;
}

.ml-19px {
  margin-left: 19px !important;
}

.ml-20px {
  margin-left: 20px !important;
}

.ml-21px {
  margin-left: 21px !important;
}

.ml-22px {
  margin-left: 22px !important;
}

.ml-23px {
  margin-left: 23px !important;
}

.ml-24px {
  margin-left: 24px !important;
}

.ml-25px {
  margin-left: 25px !important;
}

.ml-26px {
  margin-left: 26px !important;
}

.ml-27px {
  margin-left: 27px !important;
}

.ml-28px {
  margin-left: 28px !important;
}

.ml-29px {
  margin-left: 29px !important;
}

.ml-30px {
  margin-left: 30px !important;
}

.mr-5px {
  margin-right: 5px !important;
}

.mr-6px {
  margin-right: 6px !important;
}

.mr-7px {
  margin-right: 7px !important;
}

.ml-8px {
  margin-right: 8px !important;
}

.mr-9px {
  margin-right: 9px !important;
}

.mr-10px {
  margin-right: 10px !important;
}

.mr-11px {
  margin-right: 11px !important;
}

.mr-12px {
  margin-right: 12px !important;
}

.mr-13px {
  margin-right: 13px !important;
}

.mr-14px {
  margin-right: 14px !important;
}

.mr-15px {
  margin-right: 15px !important;
}

.mr-16px {
  margin-right: 16px !important;
}

.mr-17px {
  margin-right: 17px !important;
}

.mr-18px {
  margin-right: 18px !important;
}

.mr-19px {
  margin-right: 19px !important;
}

.mr-20px {
  margin-right: 20px !important;
}

.mr-21px {
  margin-right: 21px !important;
}

.mr-22px {
  margin-right: 22px !important;
}

.mr-23px {
  margin-right: 23px !important;
}

.mr-24px {
  margin-right: 24px !important;
}

.mr-25px {
  margin-right: 25px !important;
}

.mr-26px {
  margin-right: 26px !important;
}

.mr-27px {
  margin-right: 27px !important;
}

.mr-28px {
  margin-right: 28px !important;
}

.mr-29px {
  margin-right: 29px !important;
}

.mr-30px {
  margin-right: 30px !important;
}

.pr-5px {
  padding-right: 5px;
}

.pr-6px {
  padding-right: 6px;
}

.pr-7px {
  padding-right: 7px;
}

.pr-8px {
  padding-right: 8px;
}

.pr-9px {
  padding-right: 9px;
}

.pr-10px {
  padding-right: 10px;
}

.pr-11px {
  padding-right: 11px;
}

.pr-12px {
  padding-right: 12px;
}

.pr-13px {
  padding-right: 13px;
}

.pr-14px {
  padding-right: 14px;
}

.pr-15px {
  padding-right: 15px;
}

.pr-16px {
  padding-right: 16px;
}

.pr-17px {
  padding-right: 17px;
}

.pr-18px {
  padding-right: 18px;
}

.pr-19px {
  padding-right: 19px;
}

.pr-20px {
  padding-right: 20px;
}

.pr-21px {
  padding-right: 21px;
}

.pr-22px {
  padding-right: 22px;
}

.pr-23px {
  padding-right: 23px;
}

.pr-24px {
  padding-right: 24px;
}

.pr-25px {
  padding-right: 25px;
}

.pr-26px {
  padding-right: 26px;
}

.pr-27px {
  padding-right: 27px;
}

.pr-28px {
  padding-right: 28px;
}

.pr-29px {
  padding-right: 29px;
}

.pr-30px {
  padding-right: 30px;
}

.pr-35px {
  padding-right: 35px;
}

.pr-40px {
  padding-right: 40px;
}

.pr-45px {
  padding-right: 45px;
}

.pr-50px {
  padding-right: 50px;
}

.pr-55px {
  padding-right: 55px;
}

.pr-60px {
  padding-right: 60px;
}

.pl-5px {
  padding-left: 5px;
}

.pl-6px {
  padding-left: 6px;
}

.pl-7px {
  padding-left: 7px;
}

.pl-8px {
  padding-left: 8px;
}

.pl-9px {
  padding-left: 9px;
}

.pl-10px {
  padding-left: 10px;
}

.pl-11px {
  padding-left: 11px;
}

.pl-12px {
  padding-left: 12px;
}

.pl-13px {
  padding-left: 13px;
}

.pl-14px {
  padding-left: 14px;
}

.pl-15px {
  padding-left: 15px;
}

.pl-16px {
  padding-left: 16px;
}

.pl-17px {
  padding-left: 17px;
}

.pl-18px {
  padding-left: 18px;
}

.pl-19px {
  padding-left: 19px;
}

.pl-20px {
  padding-left: 20px;
}

.pl-21px {
  padding-left: 21px;
}

.pl-22px {
  padding-left: 22px;
}

.pl-23px {
  padding-left: 23px;
}

.pl-24px {
  padding-left: 24px;
}

.pl-25px {
  padding-left: 25px;
}

.pl-26px {
  padding-left: 26px;
}

.pl-27px {
  padding-left: 27px;
}

.pl-28px {
  padding-left: 28px;
}

.pl-29px {
  padding-left: 29px;
}

.pl-30px {
  padding-left: 30px;
}

.pl-35px {
  padding-left: 35px;
}

.pl-40px {
  padding-left: 40px;
}

.pl-45px {
  padding-left: 45px;
}

.pl-50px {
  padding-left: 50px;
}

.pl-55px {
  padding-left: 55px;
}

.pl-60px {
  padding-left: 60px;
}

.right-5px {
  right: 5px;
}

.right-6px {
  right: 6px;
}

.right-7px {
  right: 7px;
}

.right-8px {
  right: 8px;
}

.right-9px {
  right: 9px;
}

.right-10px {
  right: 10px;
}

.right-11px {
  right: 11px;
}

.right-12px {
  right: 12px;
}

.right-13px {
  right: 13px;
}

.right-14px {
  right: 14px;
}

.right-15px {
  right: 15px;
}

.right-16px {
  right: 16px;
}

.right-17px {
  right: 17px;
}

.right-18px {
  right: 18px;
}

.right-19px {
  right: 19px;
}

.right-20px {
  right: 20px;
}

.right-21px {
  right: 21px;
}

.right-22px {
  right: 22px;
}

.right-23px {
  right: 23px;
}

.right-24px {
  right: 24px;
}

.right-25px {
  right: 25px;
}

.right-26px {
  right: 27px;
}

.right-28px {
  right: 28px;
}

.right-29px {
  right: 29px;
}

.right-30px {
  right: 30px;
}

/* LeftSidebarNav */
.white-logo {
  display: none;
}

.sidebarLinkActive {
  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
}

.sidebarLinkActive2 {
  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
}

.sidebarLinkActive2::before {
  background-color: #fff !important;
}

.sidebarLinkActive2 {
  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  color:#fff!important;
}

/* Main wrapper content */
.main-wrapper-content {
  padding-left: 330px;
  position: relative;
  transition: all 0.5s ease-out;
  background-color: var(--themeColorLighterShade);
}
.main-wrapper-content.active {
  padding-left: 0;
}
.main-wrapper-content.active .LeftSidebarNav {
  left: -100%;
}
.main-wrapper-content.active .main-content {
  padding-left: 30px;
  padding-right: 30px;
}
.main-wrapper-content .main-content {
  padding-right: 30px;
}

@media only screen and (max-width: 767px) {
  .main-wrapper-content .main-content {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 1199px) {
  .main-wrapper-content {
    padding: 0;
  }
  .main-wrapper-content .LeftSidebarNav {
    left: -100%;
    width: 280px;
  }
  .main-wrapper-content .main-content {
    padding-left: 30px;
    padding-right: 30px;
  }
  .main-wrapper-content.active .LeftSidebarNav {
    z-index: 99999;
    left: 0;
  }
}
@media only screen and (min-width: 2200px) {
  .main-wrapper-content .main-content {
    max-width: 2200px;
    margin-left: auto;
    margin-right: auto;
  }
}
/* End Main wrapper content */
/* React Tabs Tab List */
.react-tabs__tab-list .react-tabs__tab--selected {
  background-color: var(--primaryColor);
  color: #fff;
}

/* End React Tabs Tab List */
/* Read Email */
.readEmail {
  color: var(--bodyTextColor);
  text-decoration: none;
}

.readEmail:hover {
  color: #260944;
}

/* Product Details Tabs */
.product-img-slider .swiper-button-next:after, .product-img-slider .swiper-button-prev:after {
  color: var(--primaryColor);
  font-size: 25px;
}

.product-details-tabs .react-tabs__tab-list {
  border-bottom: 1px solid #dfdfdf;
}
.product-details-tabs .react-tabs__tab-list .react-tabs__tab {
  color: #A9A9C8;
  font-weight: 500;
  font-size: 15px;
  padding-left: 0;
  padding-right: 0;
  margin-right: 30px;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 2px solid transparent;
}
.product-details-tabs .react-tabs__tab-list .react-tabs__tab:last-child {
  margin-right: 0;
}
.product-details-tabs .react-tabs__tab-list .react-tabs__tab:hover, .product-details-tabs .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {
  background-color: transparent;
  border-top: none;
  border-right: none;
  border-left: none;
  /* border-bottom: 2px solid var(--primaryColor); */
  color:var(--themeFontColor);
}
.product-details-tabs .react-tabs__tab-list .react-tabs__tab:focus:after {
  background: transparent;
}
.product-details-tabs .react-tabs__tab-panel {
  margin-top: 20px;
}
.product-details-tabs .product-description h1 {
  font-size: 22px;
  margin-top: 0;
  margin-bottom: 10px;
}
.product-details-tabs .product-description h2 {
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 10px;
}
.product-details-tabs .product-description h3 {
  font-size: 18px;
  margin-top: 0;
  margin-bottom: 10px;
}
.product-details-tabs .product-description h4 {
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 10px;
}
.product-details-tabs .product-description h5 {
  font-size: 15px;
  margin-top: 0;
  margin-bottom: 10px;
}
.product-details-tabs .product-description h6 {
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 10px;
}
.product-details-tabs .product-description p:last-child {
  margin-bottom: 0;
}
.product-details-tabs .product-description ul li, .product-details-tabs .product-description ol li {
  margin-bottom: 10px;
}
.product-details-tabs .product-description ul li:last-child, .product-details-tabs .product-description ol li:last-child {
  margin-bottom: 0;
}
.product-details-tabs .review-card .content {
  background: #F7FAFF;
  border-radius: 8px;
  position: relative;
  padding: 25px;
  margin-bottom: 30px;
}
.product-details-tabs .review-card .content .reating {
  color: #FFBC2B;
  margin-bottom: 10px;
  font-size: 15px;
}
.product-details-tabs .review-card .content .reating i {
  margin-right: 5px;
}
.product-details-tabs .review-card .content .reating i:last-child {
  margin-right: 0;
}
.product-details-tabs .review-card .content p {
  margin-top: 0;
  margin-bottom: 10px;
}
.product-details-tabs .review-card .content p:last-child {
  margin-bottom: 0;
}
.product-details-tabs .review-card .content .down-arrow {
  position: absolute;
  bottom: -20px;
  left: 25px;
}
.product-details-tabs .review-card .info {
  display: flex;
  align-items: center;
  margin-left: 30px;
}
.product-details-tabs .review-card .info img {
  border-radius: 100%;
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.product-details-tabs .review-card .info h4 {
  margin: 0;
  font-weight: 500;
  font-size: 14px;
}

/* For dark mode */
[class=dark] .product-details-tabs .react-tabs__tab-list {
  border-bottom: 1px solid var(--borderColor);
}
[class=dark] .product-details-tabs .react-tabs__tab-list .react-tabs__tab:hover, [class=dark] .product-details-tabs .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {
  color: var(--primaryColor);
}

[dir=rtl] .product-details-tabs .react-tabs__tab-list .react-tabs__tab {
  margin-right: 0;
  margin-left: 30px;
}
[dir=rtl] .product-details-tabs .react-tabs__tab-list .react-tabs__tab:last-child {
  margin-left: 0;
}
[dir=rtl] .product-details-tabs .review-card .content .reating i {
  margin-right: 0;
  margin-left: 5px;
}
[dir=rtl] .product-details-tabs .review-card .content .reating i:last-child {
  margin-left: 0;
}
[dir=rtl] .product-details-tabs .review-card .content .down-arrow {
  left: auto;
  right: 25px;
}
[dir=rtl] .product-details-tabs .review-card .info {
  margin-left: auto;
  margin-right: 30px;
}
[dir=rtl] .product-details-tabs .review-card .info img {
  margin-right: 0;
  margin-left: 10px;
}

/* Testimonial Style */
.testimonialStyle1 .swiper-button-next, .testimonialStyle1 .swiper-button-prev, .testimonialStyle2 .swiper-button-next, .testimonialStyle2 .swiper-button-prev {
  color: var(--primaryColor);
}
.testimonialStyle1 .swiper-button-next::after, .testimonialStyle1 .swiper-button-prev::after, .testimonialStyle2 .swiper-button-next::after, .testimonialStyle2 .swiper-button-prev::after {
  font-size: 25px;
}
.testimonialStyle1 .swiper-button-next, .testimonialStyle2 .swiper-button-next {
  right: 0;
}
.testimonialStyle1 .swiper-button-prev, .testimonialStyle2 .swiper-button-prev {
  left: 0;
}

[dir=rtl] .testimonialStyle1 .swiper-button-next, [dir=rtl] .testimonialStyle2 .swiper-button-next {
  right: auto;
  left: 0;
}
[dir=rtl] .testimonialStyle1 .swiper-button-prev, [dir=rtl] .testimonialStyle2 .swiper-button-prev {
  left: auto;
  right: 0;
}

.testimonialStyle3 .swiper-pagination {
  position: relative;
}
.testimonialStyle3 .swiper-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
}
.testimonialStyle3 .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: var(--primaryColor);
}

/* Active File Manager Link */
.activeFMLink > a {
  color: var(--primaryColor) !important;
}

.fc .fc-toolbar-title {
  font-size: 20px !important;
}

/* Authentication box */
.main-wrapper-content:has(div.authenticationBox) {
  padding: 0;
}

/* End Authentication box */
.apexcharts-yaxis text, .apexcharts-xaxis text {
  /* fill: var(--bodyTextColor); */
  fill:#e55e08;

}

.scroll-to-top i {
  position: fixed;
  cursor: pointer;
  bottom: 20px;
  right: 20px;
  color: #fff !important;
  background-color: var(--primaryColor);
  width: 40px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  font-size: 20px;
  transition: var(--transition);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  z-index: 1290;
}
.scroll-to-top i:hover {
  transition: var(--transition);
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  transform: translateY(-5px);
}

.control-panel-modal {
  position: fixed;
  right: -100%;
  top: 0;
  z-index: 999999;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  transition: var(--transition);
}
.control-panel-modal.show {
  right: 0;
}
.control-panel-modal .settings-btn {
  position: fixed;
  bottom: 70px;
  right: 15px;
  background-color: var(--dangerColor);
  color: #fff;
  z-index: 1290;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 100%;
  font-size: 25px;
  cursor: pointer;
  transition: var(--transition);
  animation: rotate 2s linear infinite;
}
.control-panel-modal .settings-btn:hover {
  background-color: #d32979;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.control-panel-dialog {
  width: 320px;
  background: #fff;
  height: 100%;
  margin-left: auto;
  z-index: 999999;
  position: relative;
}
.control-panel-dialog .control-panel-content {
  overflow-y: auto;
  height: 100%;
  padding-bottom: 150px;
}
.control-panel-dialog .control-panel-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #F5F5F5;
  padding: 16px 24px;
  width: 100%;
}
.css-1knvo2r-MuiPaper-root-MuiCard-root{
  border: 1px solid #363535;
}

/* dark mode */
.apexcharts-legend-text{
   color:#ff87ef;
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.scss","webpack://./src/styles/globals.css"],"names":[],"mappings":"AACA;EACE,4IAAA;EACA,+CAAA;;EAEA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gCAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;ECAF,0BAAA;EACE,8CAA8C;EDEhD;;;;;qDAIA;EACE,yBAAA;ECCF,wBAAA;EACE,+BAA+B;EDAjC,+BAAA;EACE,gCAAA;ECEF,gCAAA;EACE;;;;;qCDDF;ACOA;;AAEA;EDNA,oCAAA;EACE,6CAAA;ACIF;;ADFA;EACE,0BAAA;ACKF;;ADHA;EACE,6CAAA;ACMF;;ADHA;;GAEE;ACMF;EAKE,0CAA0C;ADT5C;ACWA;EAHA,eAAA;AAKA;;AAEA;EAHA,qBAAA;AAKA;;AAEA;EAHA,mBAAA;AAKA;;AAEA;EAHA,mBAAA;AAKA;;AAEA,UDdE;ACWF;EAKE,qCAAqC;ADdvC;;ACaA;EAKE,uCAAuC;ADdzC;;ACiBA;EAHA,qCAAA;AAKA;;AAEA;EAHA,kCAAA;AAKA;;AAEA;EAHA,qCAAA;AAKA;;AAEA;EAHA,oCAAA;AAKA;;AAEA;EAHA,kCAAA;AAKA;;AAEA,aDpBE;ACiBF;EAKE,gDAAgD;ADpBlD;;ACmBA;EAKE,kDAAkD;ADpBpD;;ACuBA;EDpBE,gDAAA;ACsBF;;AAEA;EAHA,6CAAA;AAKA;;AAEA;EDrBE,gDAAA;ACuBF;;AAEA;EAHA,+CAAA;AAKA;;AAEA;EDtBE,6CAAA;ACwBF;;AAEA,uBDvBE;ACoBF;EAKE,oCAAoC;EDvBtC,kBAAA;EACE,qCAAA;EACA,iBAAA;EACA,qBAAA;ACyBF;;AAFA;EAKE,oCAAoC;EDxBtC,kBAAA;EACE,uCAAA;EACA,iBAAA;EACA,qBAAA;AC0BF;AACA;EAHA,kCAAA;EAKE,kBAAkB;EDvBpB,qCAAA;EACE,iBAAA;ECqBF,qBAAA;AAKA;ADxBA;EACE,kCAAA;ECsBF,kBAAA;EAKE,qCAAqC;EDvBvC,iBAAA;EACE,qBAAA;ACqBF;AAKA;EDxBA,kCAAA;EACE,kBAAA;ECsBF,qCAAA;EAKE,iBAAiB;EDzBnB,qBAAA;AC2BA;AAHA;EAKE,kCAAkC;ED1BpC,kBAAA;EACE,qCAAA;ECwBF,iBAAA;EAKE,qBAAqB;AD3BvB;AC6BA;EAHA,iCAAA;EAKE,kBAAkB;ED5BpB,qCAAA;EACE,iBAAA;EC0BF,qBAAA;AAKA;AD3BA;EACE,mCAAA;ECyBF,kBAAA;EAKE,oCAAoC;ED5BtC,iBAAA;EACE,qBAAA;AC0BF;AAKA;ED7BA,oCAAA;EACE,kBAAA;EC2BF,oCAAA;EAKE,iBAAiB;ED9BnB,qBAAA;ACgCA;AAHA;EAKE,oCAAoC;ED/BtC,kBAAA;EACE,oCAAA;EC6BF,iBAAA;EAKE,qBAAqB;AD9BvB;;AC6BA;EAKE,oCAAoC;ED/BtC,kBAAA;EACE,kCAAA;EC6BF,iBAAA;EAKE,qBAAqB;ADhCvB;;AC+BA;EAKE,mCAAmC;EDjCrC,kBAAA;EACE,oCAAA;EC+BF,iBAAA;EAKE,qBAAqB;ADlCvB;ACoCA;EAHA,iCAAA;EAKE,kBAAkB;EDnCpB,yBAAA;EACE,iBAAA;ECiCF,qBAAA;AAKA;ADpCA;EACE,gCAAA;ECkCF,kBAAA;EAKE,yBAAyB;EDrC3B,iBAAA;EACE,qBAAA;ACmCF;AAKA;EDtCA,gCAAA;EACE,kBAAA;ECoCF,yBAAA;EAKE,iBAAiB;EDvCnB,qBAAA;ACyCA;AAHA;EAKE,kCAAkC;EDxCpC,kBAAA;EACE,0BAAA;ECsCF,iBAAA;EAKE,qBAAqB;ADzCvB;;ACwCA;EAKE,WAAW;AD1Cb;;ACyCA;EAKE,YAAY;AD3Cd;;AC0CA;EAKE,4BAA4B;AD5C9B;;AC2CA;EAKE,2BAA2B;AD7C7B;;AC4CA;EAKE,4BAA4B;AD9C9B;;AC6CA;EAKE,4BAA4B;AD/C9B;;AC8CA;EAKE,4BAA4B;ADhD9B;;AC+CA;EAKE,4BAA4B;ADjD9B;;ACgDA;EAKE,4BAA4B;ADlD9B;;ACiDA;EAKE,6BAA6B;ADnD/B;;ACkDA;EAKE,6BAA6B;ADpD/B;;ACmDA;EAKE,6BAA6B;ADrD/B;;ACoDA;EAKE,6BAA6B;ADtD/B;;ACqDA;EAKE,2BAA2B;ADvD7B;;ACsDA;EAKE,2BAA2B;ADtD7B;;ACqDA;EAKE,2BAA2B;ADvD7B;;ACsDA;EAKE,2BAA2B;ADxD7B;;ACuDA;EAKE,2BAA2B;ADzD7B;;ACwDA;EAKE,4BAA4B;AD1D9B;;ACyDA;EAKE,4BAA4B;AD3D9B;;AC0DA;EAKE,4BAA4B;AD5D9B;;AC2DA;EAKE,4BAA4B;AD7D9B;;AC4DA;EAKE,4BAA4B;AD9D9B;;AC6DA;EAKE,4BAA4B;AD/D9B;;AC8DA;EAKE,4BAA4B;ADhE9B;;AC+DA;EAKE,4BAA4B;ADjE9B;;ACgEA;EAKE,4BAA4B;ADlE9B;;ACiEA;EAKE,4BAA4B;ADnE9B;;ACkEA;EAKE,4BAA4B;ADpE9B;;ACmEA;EAKE,4BAA4B;ADrE9B;;ACoEA;EAKE,4BAA4B;ADtE9B;;ACqEA;EAKE,4BAA4B;ADvE9B;;ACsEA;EAKE,4BAA4B;ADxE9B;;ACuEA;EAKE,4BAA4B;ADzE9B;;ACwEA;EAKE,4BAA4B;AD1E9B;;ACyEA;EAKE,4BAA4B;AD3E9B;;AC0EA;EAKE,4BAA4B;AD5E9B;;AC2EA;EAKE,4BAA4B;AD7E9B;;AC4EA;EAKE,4BAA4B;AD9E9B;;AC6EA;EAKE,4BAA4B;AD/E9B;;AC8EA;EAKE,4BAA4B;AD9E9B;;AC6EA;EAKE,4BAA4B;AD/E9B;;AC8EA;EAKE,4BAA4B;ADhF9B;;AC+EA;EAKE,4BAA4B;ADjF9B;;ACgFA;EAKE,6BAA6B;ADlF/B;;ACiFA;EAKE,6BAA6B;ADnF/B;;ACkFA;EAKE,6BAA6B;ADpF/B;;ACmFA;EAKE,6BAA6B;ADrF/B;;ACoFA;EAKE,6BAA6B;ADtF/B;;ACqFA;EAKE,6BAA6B;ADvF/B;;ACsFA;EAKE,6BAA6B;ADxF/B;;ACuFA;EAKE,6BAA6B;ADzF/B;;ACwFA;EAKE,6BAA6B;AD1F/B;;ACyFA;EAKE,6BAA6B;AD3F/B;;AC0FA;EAKE,6BAA6B;AD5F/B;;AC2FA;EAKE,6BAA6B;AD7F/B;;AC4FA;EAKE,6BAA6B;AD9F/B;;AC6FA;EAKE,6BAA6B;AD/F/B;;AC8FA;EAKE,6BAA6B;ADhG/B;;AC+FA;EAKE,6BAA6B;ADjG/B;;ACgGA;EAKE,6BAA6B;ADlG/B;;ACiGA;EAKE,6BAA6B;ADnG/B;;ACkGA;EAKE,6BAA6B;ADpG/B;;ACmGA;EAKE,6BAA6B;ADrG/B;;ACoGA;EAKE,6BAA6B;ADtG/B;;ACqGA;EAKE,kBAAkB;ADvGpB;;ACsGA;EAKE,kBAAkB;ADxGpB;;ACuGA;EAKE,kBAAkB;ADzGpB;;ACwGA;EAKE,kBAAkB;AD1GpB;;ACyGA;EAKE,kBAAkB;AD3GpB;;AC0GA;EAKE,mBAAmB;AD5GrB;;AC2GA;EAKE,mBAAmB;AD7GrB;;AC4GA;EAKE,mBAAmB;AD5GrB;;AC2GA;EAKE,mBAAmB;AD7GrB;;AC4GA;EAKE,mBAAmB;AD9GrB;;AC6GA;EAKE,mBAAmB;AD/GrB;;AC8GA;EAKE,mBAAmB;ADhHrB;;AC+GA;EAKE,mBAAmB;ADjHrB;;ACgHA;EAKE,mBAAmB;ADlHrB;;ACiHA;EAKE,mBAAmB;ADnHrB;;ACkHA;EAKE,mBAAmB;ADpHrB;;ACmHA;EAKE,mBAAmB;ADrHrB;;ACoHA;EAKE,mBAAmB;ADtHrB;;ACqHA;EAKE,mBAAmB;ADvHrB;;ACsHA;EAKE,mBAAmB;ADxHrB;;ACuHA;EAKE,mBAAmB;ADzHrB;;ACwHA;EAKE,mBAAmB;AD1HrB;;ACyHA;EAKE,mBAAmB;AD3HrB;;AC0HA;EAKE,mBAAmB;AD5HrB;;AC2HA;EAKE,mBAAmB;AD7HrB;;AC4HA;EAKE,mBAAmB;AD9HrB;;AC6HA;EAKE,mBAAmB;AD/HrB;;AC8HA;EAKE,mBAAmB;ADhIrB;;AC+HA;EAKE,mBAAmB;ADjIrB;;ACgIA;EAKE,mBAAmB;ADlIrB;;ACiIA;EAKE,mBAAmB;ADnIrB;;ACkIA;EAKE,mBAAmB;ADpIrB;;ACmIA;EAKE,iBAAiB;ADrInB;;ACoIA;EAKE,iBAAiB;ADtInB;;ACqIA;EAKE,iBAAiB;ADvInB;;ACsIA;EAKE,iBAAiB;ADxInB;;ACuIA;EAKE,iBAAiB;ADzInB;;ACwIA;EAKE,kBAAkB;AD1IpB;;ACyIA;EAKE,kBAAkB;AD3IpB;;AC0IA;EAKE,kBAAkB;AD1IpB;;ACyIA;EAKE,kBAAkB;AD3IpB;;AC0IA;EAKE,kBAAkB;AD5IpB;;AC2IA;EAKE,kBAAkB;AD7IpB;;AC4IA;EAKE,kBAAkB;AD9IpB;;AC6IA;EAKE,kBAAkB;AD/IpB;;AC8IA;EAKE,kBAAkB;ADhJpB;;AC+IA;EAKE,kBAAkB;ADjJpB;;ACgJA;EAKE,kBAAkB;ADlJpB;;ACiJA;EAKE,kBAAkB;ADnJpB;;ACkJA;EAKE,kBAAkB;ADpJpB;;ACmJA;EAKE,kBAAkB;ADrJpB;;ACoJA;EAKE,kBAAkB;ADtJpB;;ACqJA;EAKE,kBAAkB;ADvJpB;;ACsJA;EAKE,kBAAkB;ADxJpB;;ACuJA;EAKE,kBAAkB;ADzJpB;;ACwJA;EAKE,kBAAkB;AD1JpB;;ACyJA;EAKE,kBAAkB;AD3JpB;;AC0JA;EAKE,kBAAkB;AD5JpB;;AC2JA;EAKE,kBAAkB;AD7JpB;;AC4JA;EAKE,kBAAkB;AD9JpB;;AC6JA;EAKE,kBAAkB;AD/JpB;;AC8JA;EAKE,kBAAkB;ADhKpB;;AC+JA;EAKE,kBAAkB;ADjKpB;;ACgKA;EAKE,kBAAkB;ADlKpB;;ACiKA;EAKE,UAAU;ADlKZ;;ACqKA;EAHA,UAAA;AAKA;;AAEA;EAHA,UAAA;AAKA;;AAEA;EAHA,UAAA;AAKA;;AAEA;EAHA,UAAA;AAKA;;AAEA;EDtKE,WAAA;ACoKF;;ADjKA;EACA,WAAA;ACwKA;;AAEA;EAHA,WAAA;ADlKE;;ACqKF;EDlKI,WAAA;ACwKJ;;ADrKI;EACE,WAAA;ACwKN;;ADnKE;EACE,WAAA;ACkKJ;;AD9JA;EAEI,WAAA;ACoKJ;;AAEA;EAHA,WAAA;AD5JA;;ACmKA;EAHE,WAAA;AAKF;;AAEA;EAHE,WAAA;AAKF;;AAEA;EAHE,WAAA;AAKF;;AAEA;EAHE,WAAA;AACF;;AAMA;EACE,WD5JI;AC6JN;;AAEA;EAHA,WAAA;ADtJA;;AAIE;EACE,WAAA;AC0JJ;;AAEA;EDxJA,WAAA;AAEA;;AC0JA;EDvJE,WAAA;ACqJF;;ADnJA;EACE,WAAA;ACsJF;;ADnJA;EAEE,WAAA;ACyJF;;AAFA;EAKE,WAAW;ADtJX;;ACqJF,mBAAA;ADlJI;EACE,aAAA;ACwJN;;AAEA;EDtJM,4FAAA;ACwJN;;AAEA;EDtJM,4FAAA;ACwJN;;ADrJM;EACE,iCAAA;ACoJR;;AAMA;EDrJQ,4FAAA;EACA,oBAAA;ACuJR;;AAEA,yBDtJQ;ACmJR;EDhJM,mBAAA;EACE,kBAAA;ECkJR,6BAAA;ED9IE,+CAAA;ACoJF;AAHA;ED7II,eAAA;ACmJJ;AACA;EDjJM,WAAA;AC+IN;AD7II;EACE,kBAAA;EACA,mBAAA;ACmJN;AAHA;ED7II,mBAAA;ACmJJ;;AAEA;EAHA;ID7II,6BAAA;IACE,8BAAA;EACA;ACmJN;AAHA;ED7II;IACE,UAAA;EACA;EACA;IC+IN,WAAA;ID7II,YAAA;EACE;EACA;IACA,kBAAA;IC+IN,mBAAA;ED5IM;EACE;IC8IR,cAAA;ID1IM,OAAA;EACE;AC4IR;AD3IQ;EACE;IC6IV,iBAAA;IDvII,iBAAA;IACE,kBAAA;EACA;AC6IN;AACA,6BD5IM;AC6IN,wBD5IM;ACyIN;EDvIM,qCAAA;EACE,WAAA;AC6IR;;AAFA,4BAAA;ADxIQ,eAAA;AC8IR;EAHA,2BAAA;EDzIU,qBAAA;AC+IV;;AD1IM;EACE,cAAA;AC6IR;;AD3IQ,yBAAA;AC8IR;EAHA,0BAAA;EDvIM,eAAA;AC6IN;;AAEA;EAHA,gCAAA;ADtII;AC4IJ;ED1IM,cAAA;EACA,gBAAA;ECwIN,eAAA;EDvIM,eAAA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;ECyIR,iBAAA;EDvIM,oCAAA;AC6IN;AACA;ED3IQ,eAAA;ACyIR;AAKA;EDxIA,6BAAA;EAEE,gBAAA;EACI,kBAAA;ECqIN,iBAAA;EDnIM,kDAAA;EACE,2BAAA;ACqIR;AAKA;ED/HM,uBAAA;ACiIN;AACA;EAHA,gBAAA;AD3HQ;ACiIR;EAHA,eAAA;EDrHU,aAAA;EACE,mBAAA;AC2HZ;AAHA;EDrHY,eAAA;EACE,aAAA;ECuHd,mBAAA;ADnHQ;ACyHR;EDvHU,eAAA;ECqHV,aAAA;EDlHM,mBAAA;ACwHN;AACA;EAHA,eAAA;EDnHQ,aAAA;EACE,mBAAA;ACyHV;AAHA;EAKE,eAAe;EDlHjB,aAAA;EAEE,mBAAA;ACmHF;AAHA;ED9GI,eAAA;EACE,aAAA;ECgHN,mBAAA;AD7GE;ACmHF;EAHA,gBAAA;AD7GE;ACmHF;EAHA,mBAAA;AAKA;AD/GI;EACE,gBAAA;ACiHN;AAHA;ED3GI,mBAAA;EACE,kBAAA;EACA,kBAAA;EC6GN,aAAA;EAKE,mBAAmB;AD7GnB;AC+GF;EAHA,cAAA;ED1GI,mBAAA;EACE,eAAA;ACgHN;AAHA;ED3GM,iBAAA;ACiHN;AAHA;EAKE,eAAe;AD5GjB;AAEE;EACE,aAAA;ECyGJ,mBAAA;AAKA;ADxGE;EACE,gBAAA;ACsGJ;AAKA;EDvGA,kBAAA;EACA,aAAA;EACE,UAAA;ACqGF;AAKA;EDxGA,aAAA;EAIE,mBAAA;EACE,iBAAA;ACmGJ;AAKA;EDlGE,mBAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACoGJ;AACA;EDlGI,SAAA;EACA,gBAAA;EACA,eAAA;ACoGJ;;AAEA,kBDnGI;ACoGJ;EDlGI,2CAAA;ACoGJ;AACA;EAHA,0BAAA;AD9FI;;ACqGJ;EDjGM,eAAA;EC+FN,iBAAA;AAKA;AD9FA;EACE,cAAA;ACgGF;AACA;ED9FE,eAAA;EACA,gBAAA;ACgGF;AACA;ED9FE,cAAA;AC4FF;AD1FE;EACE,UAAA;EC4FJ,WAAA;ADzFE;AC+FF;ED7FI,iBAAA;EACA,kBAAA;AC+FJ;AACA;ED7FI,eAAA;EACA,iBAAA;AC+FJ;;AAEA,sBD9FI;AC+FJ;ED7FI,0BAAA;AC+FJ;AACA;ED7FI,eAAA;AC2FJ;ADzFI;EACE,QAAA;AC2FN;AAKA;ED5FA,OAAA;AC8FA;;AAEA;ED5FE,WAAA;EC8FA,OD7FE;AC8FJ;AAHA;EDxFA,UAAA;EACE,QAAA;AC8FF;;AAEA;ED5FE,kBAAA;AC8FF;AAHA;EDxFE,WAAA;EACE,YAAA;AC8FJ;AACA;EAHA,qCAAA;ADvFE;;AC8FF,6BD5FI;AC6FJ;ED3FI,qCAAA;AC6FJ;;AAFA;EAKE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,YAAY;;AAEd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,2EAA2E;EAC3E,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,eAAe;EACf,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;GACG,aAAa;AAChB","sourcesContent":["// Globals variables\n:root {\n  --bodyFontFamily: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif !important;\n  --bodyTextColor: #5B5B98;\n  --primaryColor: #000000;\n  --secondaryColor: #818093;\n  --successColor: #00B69B;\n  --infoColor: #2DB6F5;\n  --warningColor: #FFBC2B;\n  --dangerColor: #EE368C;\n  --darkColor: #260944;\n  --headingColor: #260944;\n  --whiteColor: #ffffff;\n  --fontSize: 15px;\n  --transition: all ease .5s;\n  --box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.05);\n}\n\nhtml, body {\n  background-color: #F5F5F5 !important;\n  font-family: var(--bodyFontFamily) !important; \n}\nh1, h2, h3, h4, h5, h6 {\n  color: var(--headingColor);\n}\ndiv, label, a, p, tspan, span, li, table, tbody, tfoot, thead, th, td, canvas, button, input, ::placeholder, abbr, address, blockquote, caption, cite, code, dd, dl, mark, option, pre, select, time, del {\n  font-family: var(--bodyFontFamily) !important;\n}\nimg {\n  max-width: 100%; \n} \n.text-decoration-none {\n  text-decoration: none; \n}\n.borRadius100 {\n  border-radius: 100%; \n}\n.borderRadius10 {\n  border-radius: 10px;\n}\n\n/* Color */\n.primaryColor {\n  color: var(--primaryColor) !important;\n}\n.secondaryColor {\n  color: var(--secondaryColor) !important;\n}\n.successColor {\n  color: var(--successColor) !important;\n}\n.infoColor {\n  color: var(--infoColor) !important;\n}\n.warningColor {\n  color: var(--warningColor) !important;\n}\n.dangerColor {\n  color: var(--dangerColor) !important;\n}\n.darkColor {\n  color: var(--darkColor) !important;\n}\n\n/* BG Color */\n.primaryBgColor {\n  background-color: var(--primaryColor) !important;\n}\n.secondaryBgColor {\n  background-color: var(--secondaryColor) !important;\n}\n.successBgColor {\n  background-color: var(--successColor) !important;\n}\n.infoBgColor {\n  background-color: var(--infoColor) !important;\n}\n.warningBgColor {\n  background-color: var(--warningColor) !important;\n}\n.dangerBgColor {\n  background-color: var(--dangerColor) !important;\n}\n.darkBgColor {\n  background-color: var(--darkColor) !important;\n}\n \n/* Badge custom style */\n.primaryBadge {\n  background: rgba(117, 127, 239, 0.1);\n  border-radius: 4px;\n  color: var(--primaryColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.secondaryBadge {\n  background: rgba(117, 127, 239, 0.1);\n  border-radius: 4px;\n  color: var(--secondaryColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.successBadge {\n  background: rgba(0, 182, 155, 0.1);\n  border-radius: 4px;\n  color: var(--successColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.infoBadge {\n  background: rgba(117, 127, 239, 0.1);\n  border-radius: 4px;\n  color: var(--infoColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.dangerBadge {\n  background: rgba(238, 54, 140, 0.1);\n  border-radius: 4px;\n  color: var(--dangerColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n\n// Float\n.float-left {\n  float: left;\n}\n.float-right {\n  float: right;\n}\n\n// Margin Left\n.ml-auto {\n  margin-left: auto !important; \n}\n.ml-1 {\n  margin-left: 8px !important;\n}\n.ml-2 {\n  margin-left: 16px !important;\n}\n.ml-3 {\n  margin-left: 24px !important;\n}\n.ml-4 {\n  margin-left: 32px !important;\n}\n.ml-5 {\n  margin-left: 40px !important;\n}\n\n// Margin Right\n.mr-1 {\n  margin-right: 8px !important;\n}\n.mr-2 {\n  margin-right: 16px !important; \n}\n.mr-3 {\n  margin-right: 24px !important;\n}\n.mr-4 {\n  margin-right: 32px !important;\n}\n.mr-5 {\n  margin-right: 40px !important;\n}\n\n// Margin Left\n.ml-5px {\n  margin-left: 5px !important;\n}\n.ml-6px {\n  margin-left: 6px !important;\n}\n.ml-7px {\n  margin-left: 7px !important;\n}\n.ml-8px {\n  margin-left: 8px !important;\n}\n.ml-9px {\n  margin-left: 9px !important;\n}\n.ml-10px {\n  margin-left: 10px !important;\n}\n.ml-11px {\n  margin-left: 11px !important;\n}\n.ml-12px {\n  margin-left: 12px !important;\n}\n.ml-13px {\n  margin-left: 13px !important;\n}\n.ml-14px {\n  margin-left: 14px !important;\n}\n.ml-15px {\n  margin-left: 15px !important;\n}\n.ml-16px {\n  margin-left: 16px !important;\n}\n.ml-17px {\n  margin-left: 17px !important;\n}\n.ml-18px {\n  margin-left: 18px !important;\n}\n.ml-19px {\n  margin-left: 19px !important;\n}\n.ml-20px {\n  margin-left: 20px !important;\n}\n.ml-21px {\n  margin-left: 21px !important;\n}\n.ml-22px {\n  margin-left: 22px !important;\n}\n.ml-23px {\n  margin-left: 23px !important;\n}\n.ml-24px {\n  margin-left: 24px !important;\n}\n.ml-25px {\n  margin-left: 25px !important;\n}\n.ml-26px {\n  margin-left: 26px !important;\n}\n.ml-27px {\n  margin-left: 27px !important;\n}\n.ml-28px {\n  margin-left: 28px !important;\n}\n.ml-29px {\n  margin-left: 29px !important;\n}\n.ml-30px {\n  margin-left: 30px !important;\n}\n\n// Margin Right\n.mr-5px {\n  margin-right: 5px !important;\n}\n.mr-6px {\n  margin-right: 6px !important;\n}\n.mr-7px {\n  margin-right: 7px !important;\n}\n.ml-8px {\n  margin-right: 8px !important;\n}\n.mr-9px {\n  margin-right: 9px !important;\n}\n.mr-10px {\n  margin-right: 10px !important;\n}\n.mr-11px {\n  margin-right: 11px !important;\n}\n.mr-12px {\n  margin-right: 12px !important;\n}\n.mr-13px {\n  margin-right: 13px !important;\n}\n.mr-14px {\n  margin-right: 14px !important;\n}\n.mr-15px {\n  margin-right: 15px !important;\n}\n.mr-16px {\n  margin-right: 16px !important;\n}\n.mr-17px {\n  margin-right: 17px !important;\n}\n.mr-18px {\n  margin-right: 18px !important;\n}\n.mr-19px {\n  margin-right: 19px !important;\n}\n.mr-20px {\n  margin-right: 20px !important;\n}\n.mr-21px {\n  margin-right: 21px !important;\n}\n.mr-22px {\n  margin-right: 22px !important;\n}\n.mr-23px {\n  margin-right: 23px !important;\n}\n.mr-24px {\n  margin-right: 24px !important;\n}\n.mr-25px {\n  margin-right: 25px !important;\n}\n.mr-26px {\n  margin-right: 26px !important;\n}\n.mr-27px {\n  margin-right: 27px !important;\n}\n.mr-28px {\n  margin-right: 28px !important;\n}\n.mr-29px {\n  margin-right: 29px !important;\n}\n.mr-30px {\n  margin-right: 30px !important;\n}\n\n// Padding Right\n.pr-5px {\n  padding-right: 5px;\n}\n.pr-6px {\n  padding-right: 6px;\n}\n.pr-7px {\n  padding-right: 7px;\n}\n.pr-8px {\n  padding-right: 8px;\n}\n.pr-9px {\n  padding-right: 9px;\n}\n.pr-10px {\n  padding-right: 10px;\n}\n.pr-11px {\n  padding-right: 11px;\n}\n.pr-12px {\n  padding-right: 12px;\n}\n.pr-13px {\n  padding-right: 13px;\n}\n.pr-14px {\n  padding-right: 14px;\n}\n.pr-15px {\n  padding-right: 15px;\n}\n.pr-16px {\n  padding-right: 16px;\n}\n.pr-17px {\n  padding-right: 17px;\n}\n.pr-18px {\n  padding-right: 18px;\n}\n.pr-19px {\n  padding-right: 19px;\n}\n.pr-20px {\n  padding-right: 20px;\n}\n.pr-21px {\n  padding-right: 21px;\n}\n.pr-22px {\n  padding-right: 22px;\n}\n.pr-23px {\n  padding-right: 23px;\n}\n.pr-24px {\n  padding-right: 24px;\n}\n.pr-25px {\n  padding-right: 25px;\n}\n.pr-26px {\n  padding-right: 26px;\n}\n.pr-27px {\n  padding-right: 27px;\n}\n.pr-28px {\n  padding-right: 28px;\n}\n.pr-29px {\n  padding-right: 29px;\n}\n.pr-30px {\n  padding-right: 30px;\n}\n.pr-35px {\n  padding-right: 35px;\n}\n.pr-40px {\n  padding-right: 40px;\n}\n.pr-45px {\n  padding-right: 45px;\n}\n.pr-50px {\n  padding-right: 50px;\n}\n.pr-55px {\n  padding-right: 55px;\n}\n.pr-60px {\n  padding-right: 60px;\n}\n\n// Padding Left\n.pl-5px {\n  padding-left: 5px;\n}\n.pl-6px {\n  padding-left: 6px;\n}\n.pl-7px {\n  padding-left: 7px;\n}\n.pl-8px {\n  padding-left: 8px;\n}\n.pl-9px {\n  padding-left: 9px;\n}\n.pl-10px {\n  padding-left: 10px;\n}\n.pl-11px {\n  padding-left: 11px;\n}\n.pl-12px {\n  padding-left: 12px;\n}\n.pl-13px {\n  padding-left: 13px;\n}\n.pl-14px {\n  padding-left: 14px;\n}\n.pl-15px {\n  padding-left: 15px;\n}\n.pl-16px {\n  padding-left: 16px;\n}\n.pl-17px {\n  padding-left: 17px;\n}\n.pl-18px {\n  padding-left: 18px;\n}\n.pl-19px {\n  padding-left: 19px;\n}\n.pl-20px {\n  padding-left: 20px;\n}\n.pl-21px {\n  padding-left: 21px;\n}\n.pl-22px {\n  padding-left: 22px;\n}\n.pl-23px {\n  padding-left: 23px;\n}\n.pl-24px {\n  padding-left: 24px;\n}\n.pl-25px {\n  padding-left: 25px;\n}\n.pl-26px {\n  padding-left: 26px;\n}\n.pl-27px {\n  padding-left: 27px;\n}\n.pl-28px {\n  padding-left: 28px;\n}\n.pl-29px {\n  padding-left: 29px;\n}\n.pl-30px {\n  padding-left: 30px;\n}\n.pl-35px {\n  padding-left: 35px;\n}\n.pl-40px {\n  padding-left: 40px;\n}\n.pl-45px {\n  padding-left: 45px;\n}\n.pl-50px {\n  padding-left: 50px;\n}\n.pl-55px {\n  padding-left: 55px;\n}\n.pl-60px {\n  padding-left: 60px;\n}\n\n// Right\n.right-5px {\n  right: 5px;\n}\n.right-6px {\n  right: 6px;\n}\n.right-7px {\n  right: 7px;\n}\n.right-8px {\n  right: 8px;\n}\n.right-9px {\n  right: 9px;\n}\n.right-10px {\n  right: 10px;\n}\n.right-11px {\n  right: 11px;\n}\n.right-12px {\n  right: 12px;\n}\n.right-13px {\n  right: 13px;\n}\n.right-14px {\n  right: 14px;\n}\n.right-15px {\n  right: 15px;\n}\n.right-16px {\n  right: 16px;\n}\n.right-17px {\n  right: 17px;\n}\n.right-18px {\n  right: 18px;\n}\n.right-19px {\n  right: 19px;\n}\n.right-20px {\n  right: 20px;\n}\n.right-21px {\n  right: 21px;\n}\n.right-22px {\n  right: 22px;\n}\n.right-23px {\n  right: 23px;\n}\n.right-24px {\n  right: 24px;\n}\n.right-25px {\n  right: 25px;\n}\n.right-26px {\n  right: 27px;\n}\n.right-28px {\n  right: 28px;\n}\n.right-29px {\n  right: 29px;\n}\n.right-30px {\n  right: 30px;\n}\n\n/* LeftSidebarNav */\n.white-logo {\n  display: none;\n}\n.sidebarLinkActive {\n  background: linear-gradient(225deg, rgb(0 84 148) 0%, rgb(213 2 127) 91.25%);\n}\n.sidebarLinkActive2 {\n  background: linear-gradient(225deg, rgb(0 84 148) 0%, rgb(213 2 127) 91.25%);\n}\n.sidebarLinkActive2::before {\n  background-color: #fff !important;\n}\n.sidebarLinkActive2 {\n  background: linear-gradient(225deg, rgb(0 84 148) 0%, rgb(213 2 127) 91.25%); \n  color: #fff !important;\n}\n\n/* Main wrapper content */\n.main-wrapper-content {\n  padding-left: 330px;\n  position: relative;\n  transition: all 0.5s ease-out;\n\n  &.active {\n    padding-left: 0;\n\n    .LeftSidebarNav {\n      left: -100%;\n    }\n    .main-content {\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n  }\n\n  .main-content {\n    padding-right: 30px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .main-wrapper-content {\n    .main-content {\n      padding-left: 15px !important;\n      padding-right: 15px !important;\n    }\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .main-wrapper-content {\n    padding: 0;\n \n    .LeftSidebarNav { \n      left: -100%;\n      width: 280px;\n    }\n    .main-content {\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n\n    &.active {\n      .LeftSidebarNav {\n        z-index: 99999;\n        left: 0;\n      }\n    }\n  }\n}\n@media only screen and (min-width: 2200px) {\n  .main-wrapper-content {\n    .main-content {\n      max-width: 2200px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n}\n/* End Main wrapper content */\n\n/* React Tabs Tab List */\n.react-tabs__tab-list {\n  .react-tabs__tab--selected {\n    background-color: var(--primaryColor);\n    color: #fff; \n  }\n}\n/* End React Tabs Tab List */\n\n/* Read Email */\n.readEmail {\n  color: var(--bodyTextColor);\n  text-decoration: none;\n}\n.readEmail:hover {\n  color: #260944;\n}\n\n/* Product Details Tabs */\n.product-img-slider {\n  .swiper-button-next:after, .swiper-button-prev:after {\n    color: var(--primaryColor);\n    font-size: 25px;\n  }\n}\n.product-details-tabs {\n  .react-tabs__tab-list {\n    border-bottom: 1px solid #dfdfdf;\n\n    .react-tabs__tab { \n      color: #A9A9C8;\n      font-weight: 500;\n      font-size: 15px; \n      padding-left: 0;\n      padding-right: 0;\n      margin-right: 30px;\n      border-top: none;\n      border-right: none;\n      border-left: none;\n      border-bottom: 2px solid transparent;\n\n      &:last-child {\n        margin-right: 0;\n      }\n\n      &:hover, &.react-tabs__tab--selected {\n        background-color: transparent;\n        border-top: none;\n        border-right: none;\n        border-left: none;\n        border-bottom: 2px solid var(--primaryColor);\n        color: #260944;\n      }\n\n      &:focus:after {\n        background: transparent;\n      }\n    }\n  }\n  .react-tabs__tab-panel {\n    margin-top: 20px;\n  }\n  .product-description {\n    h1 {\n      font-size: 22px;\n      margin-top: 0;\n      margin-bottom: 10px;\n    }\n    h2 {\n      font-size: 20px;\n      margin-top: 0;\n      margin-bottom: 10px;\n    }\n    h3 {\n      font-size: 18px;\n      margin-top: 0;\n      margin-bottom: 10px;\n    }\n    h4 {\n      font-size: 16px;\n      margin-top: 0;\n      margin-bottom: 10px;\n    }\n    h5 {\n      font-size: 15px;\n      margin-top: 0;\n      margin-bottom: 10px;\n    }\n    h6 {\n      font-size: 14px;\n      margin-top: 0;\n      margin-bottom: 10px;\n    }\n    p {\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n    ul, ol {\n      li {\n        margin-bottom: 10px;\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n  .review-card {\n    .content {\n      background: #F7FAFF;\n      border-radius: 8px;\n      position: relative;\n      padding: 25px;\n      margin-bottom: 30px;\n\n      .reating {\n        color: #FFBC2B;\n        margin-bottom: 10px;\n        font-size: 15px;\n        i {\n          margin-right: 5px;\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n      }\n      p {\n        margin-top: 0;\n        margin-bottom: 10px;\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n      .down-arrow {\n        position: absolute;\n        bottom: -20px;\n        left: 25px;\n      }\n    }\n    .info {\n      display: flex;\n      align-items: center;\n      margin-left: 30px;\n      img {\n        border-radius: 100%;\n        width: 30px;\n        height: 30px;\n        margin-right: 10px;\n      }\n      h4 {\n        margin: 0;\n        font-weight: 500;\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n/* For dark mode */\n[class=\"dark\"] .product-details-tabs {\n  .react-tabs__tab-list {\n      border-bottom: 1px solid var(--borderColor);\n    .react-tabs__tab { \n      &:hover, &.react-tabs__tab--selected {\n        color: var(--primaryColor);\n      }\n    }\n  }\n}\n\n\n// For RTL Style\n[dir=\"rtl\"] {\n  .product-details-tabs {\n    .react-tabs__tab-list {\n      .react-tabs__tab { \n        margin-right: 0;\n        margin-left: 30px;\n  \n        &:last-child {\n          margin-left: 0;\n        }\n      }\n    }\n\n    .review-card {\n      .content {\n        .reating {\n          i {\n            margin-right: 0;\n            margin-left: 5px;\n\n            &:last-child {\n              margin-left: 0;\n            }\n          }\n        }\n        .down-arrow {\n          left: auto;\n          right: 25px;\n        }\n      }\n      .info {\n        margin-left: auto;\n        margin-right: 30px;\n        img {\n          margin-right: 0;\n          margin-left: 10px;\n        }\n      }\n    }\n  }\n}\n\n\n/* Testimonial Style */\n.testimonialStyle1, .testimonialStyle2 {\n  .swiper-button-next, .swiper-button-prev {\n    color: var(--primaryColor);\n    &::after {\n      font-size: 25px;\n    }\n  }\n  .swiper-button-next {\n    right: 0;\n  }\n  .swiper-button-prev {\n    left: 0;\n  }\n}\n[dir=\"rtl\"] {\n  .testimonialStyle1, .testimonialStyle2 {\n    .swiper-button-next {\n      right: auto;\n      left: 0;\n    }\n    .swiper-button-prev {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n.testimonialStyle3 {\n  .swiper-pagination{\n    position: relative;\n    .swiper-pagination-bullet {\n      width: 10px;\n      height: 10px;\n      &.swiper-pagination-bullet-active {\n        background-color: var(--primaryColor);\n      }\n    }\n  }\n}\n\n/* Active File Manager Link */\n.activeFMLink {\n  > a {\n    color: var(--primaryColor) !important; \n  }\n}\n\n// Calendar Title\n.fc {\n  .fc-toolbar-title {\n    font-size: 20px !important;\n  }\n}\n\n/* Authentication box */\n.main-wrapper-content:has(div.authenticationBox) { \n  padding: 0;\n}\n/* End Authentication box */\n\n// apexcharts\n.apexcharts-yaxis, .apexcharts-xaxis {\n  text {\n    fill: var(--bodyTextColor);\n  }\n}\n\n// Scroll To Top CSS\n.scroll-to-top {\n  i {\n    position: fixed;\n    cursor: pointer;\n    bottom: 20px;\n    right: 20px;\n    color: #fff !important;\n    background-color: var(--primaryColor);\n    width: 40px;\n    text-align: center;\n    height: 40px;\n    line-height: 40px;\n    border-radius: 50%;\n    font-size: 20px;\n    transition: var(--transition);\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);\n    z-index: 1290;\n\n    &:hover {\n      transition: var(--transition);\n      box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),\n        0 1px 3px rgba(0, 0, 0, 0.08);\n      transform: translateY(-5px);\n    }\n  }\n}\n \n// control-panel-modal\n.control-panel-modal {\n  position: fixed;\n  right: -100%;\n  top: 0;\n  z-index: 999999;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, .2);\n  transition: var(--transition);\n\n  &.show {\n    right: 0;\n  }\n\n  .settings-btn {\n    position: fixed;\n    bottom: 70px;\n    right: 15px;\n    background-color: var(--dangerColor);\n    color: #fff;\n    z-index: 1290;\n    width: 50px;\n    height: 50px;\n    text-align: center;\n    line-height: 50px;\n    border-radius: 100%;\n    font-size: 25px;\n    cursor: pointer;\n    transition: var(--transition);\n    animation: rotate 2s linear infinite;\n   \n    &:hover {\n      background-color: #d32979;\n    }\n  }\n}\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.control-panel-dialog {\n  width: 320px;\n  background: #fff;\n  height: 100%;\n  margin-left: auto;\n  z-index: 999999;\n  position: relative;\n\n  .control-panel-content {\n    overflow-y: auto;\n    height: 100%;\n    padding-bottom: 150px;\n  }\n\n  .control-panel-footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: #F5F5F5;\n    padding: 16px 24px;\n    width: 100%;\n  }\n}\n",":root {\n  /* --bodyFontFamily: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif !important; */\n  --bodyFontFamily: \"JesayaBk-Regular\" !important;\n\n  --bodyTextColor: #000000;\n  --primaryColor: #000000;\n  --secondaryColor: #818093;\n  --successColor: #00B69B;\n  --infoColor: #2DB6F5;\n  --warningColor: #FFBC2B;\n  --dangerColor: rgb(238, 54, 140);\n  --darkColor: #260944;\n  --headingColor: #260944;\n  --whiteColor: #ffffff;\n  --fontSize: 15px;\n  --transition: all ease .5s;\n  --box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.05);\n  /* --gradientColor1:#e25d65;\n  --gradientColor2:#9d58a3;\n  --gradientColorLighter1:rgba(226, 93, 102, 0.88);\n  --gradientColorLighter2:rgba(157, 88, 163, 0.8);\n  --gradientColorLightest1:rgba(226, 93, 102, 0.48);\n  --gradientColorLightest2:rgba(157, 88, 163, 0.4); */\n  --gradientColor1: #DC5F00;\n  --gradientColor2:#DC5F00;\n  --gradientColorLighter1:#DC5F00;\n  --gradientColorLighter2:#DC5F00;\n  --gradientColorLightest1:#DC5F00;\n  --gradientColorLightest2:#DC5F00;\n  /* --gradientColor2:   #5c5858;\n  --gradientColor1: #232023;\n  --gradientColorLighter2:#5c5858;\n  --gradientColorLighter1:#232023;\n  --gradientColorLightest2:#5c5858;\n  --gradientColorLightest1:#232023; */\n}\n\nhtml, body {\n  background-color: #F5F5F5 !important;\n  font-family: var(--bodyFontFamily) !important;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: var(--headingColor);\n}\n\n::-moz-placeholder {\n  font-family: var(--bodyFontFamily) !important;\n}\n\n/* div, label, a, p, tspan, span, li, table, tbody, tfoot, thead, th, td, canvas, button, input, ::placeholder, abbr, address, blockquote, caption, cite, code, dd, dl, mark, option, pre, select, time, del {\n  font-family: var(--bodyFontFamily) !important;\n} */\ndiv, label, a, p, tspan, span, li, table, tbody, tfoot, thead, th, td, canvas, button, input, ::placeholder, abbr, address, blockquote, caption, cite, code, dd, dl, mark, option, pre, select, time, del {\n  font-family:\"JesayaBk-Regular\"  !important;\n}\nimg {\n  max-width: 100%;\n}\n\n.text-decoration-none {\n  text-decoration: none;\n}\n\n.borRadius100 {\n  border-radius: 100%;\n}\n\n.borderRadius10 {\n  border-radius: 10px;\n}\n\n/* Color */\n.primaryColor {\n  color: var(--primaryColor) !important;\n}\n\n.secondaryColor {\n  color: var(--secondaryColor) !important;\n}\n\n.successColor {\n  color: var(--successColor) !important;\n}\n\n.infoColor {\n  color: var(--infoColor) !important;\n}\n\n.warningColor {\n  color: var(--warningColor) !important;\n}\n\n.dangerColor {\n  color: var(--dangerColor) !important;\n}\n\n.darkColor {\n  color: var(--darkColor) !important;\n}\n\n/* BG Color */\n.primaryBgColor {\n  background-color: var(--primaryColor) !important;\n}\n\n.secondaryBgColor {\n  background-color: var(--secondaryColor) !important;\n}\n\n.successBgColor {\n  background-color: var(--successColor) !important;\n}\n\n.infoBgColor {\n  background-color: var(--infoColor) !important;\n}\n\n.warningBgColor {\n  background-color: var(--warningColor) !important;\n}\n\n.dangerBgColor {\n  background-color: var(--dangerColor) !important;\n}\n\n.darkBgColor {\n  background-color: var(--darkColor) !important;\n}\n\n/* Badge custom style */\n.primaryBadge {\n  background: rgba(117, 127, 239, 0.1);\n  border-radius: 4px;\n  color: var(--primaryColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n\n.secondaryBadge {\n  background: rgba(117, 127, 239, 0.1);\n  border-radius: 4px;\n  color: var(--secondaryColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.successBadge {\n  background: rgba(0, 182, 155, 0.1);\n  border-radius: 4px;\n  color: var(--successColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.SuccessBadge {\n  background: rgba(0, 182, 155, 0.1);\n  border-radius: 4px;\n  color: var(--successColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.ActiveBadge {\n  background: rgba(0, 182, 155, 0.1);\n  border-radius: 4px;\n  color: var(--successColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.ApprovedBadge,.CreateBadge{\n  background: rgba(0, 182, 155, 0.1);\n  border-radius: 4px;\n  color: var(--successColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.PendingBadge,.UpdateBadge , .ExpiringSoonBadge {\n  background: rgba(235, 97, 6, 0.1);\n  border-radius: 4px;\n  color: var(--warningColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.InactiveBadge {\n  background: rgba(238, 54, 140, 0.1);\n  border-radius: 4px;\n  color: var(--dangerColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.FailedBadge {\n  background:  rgba(238, 54, 140, 0.1);\n  border-radius: 4px;\n  color: var(--dangerColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.ExpiredBadge,.RejectedBadge,.DeleteBadge {\n  background:  rgba(238, 54, 140, 0.1);\n  border-radius: 4px;\n  color: var(--dangerColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n\n.infoBadge {\n  background: rgba(117, 127, 239, 0.1);\n  border-radius: 4px;\n  color: var(--infoColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n\n.dangerBadge {\n  background: rgba(238, 54, 140, 0.1);\n  border-radius: 4px;\n  color: var(--dangerColor) !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.ActorBadge {\n  background: rgb(123, 198, 204,.1);\n  border-radius: 4px;\n  color: #7BC6CC !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.ActressBadge {\n  background:rgb(190, 147, 197,.1);\n  border-radius: 4px;\n  color: #BE93C5 !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.DirectorBadge {\n  background:rgb(176, 218, 185,.1);\n  border-radius: 4px;\n  color: #B0DAB9 !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n.ProducerBadge {\n  background:  rgb(255, 195, 113,.1);\n  border-radius: 4px;\n  color:  #FFC371 !important;\n  padding: 5px 13px;\n  display: inline-block;\n}\n\n.float-left {\n  float: left;\n}\n\n.float-right {\n  float: right;\n}\n\n.ml-auto {\n  margin-left: auto !important;\n}\n\n.ml-1 {\n  margin-left: 8px !important;\n}\n\n.ml-2 {\n  margin-left: 16px !important;\n}\n\n.ml-3 {\n  margin-left: 24px !important;\n}\n\n.ml-4 {\n  margin-left: 32px !important;\n}\n\n.ml-5 {\n  margin-left: 40px !important;\n}\n\n.mr-1 {\n  margin-right: 8px !important;\n}\n\n.mr-2 {\n  margin-right: 16px !important;\n}\n\n.mr-3 {\n  margin-right: 24px !important;\n}\n\n.mr-4 {\n  margin-right: 32px !important;\n}\n\n.mr-5 {\n  margin-right: 40px !important;\n}\n\n.ml-5px {\n  margin-left: 5px !important;\n}\n\n.ml-6px {\n  margin-left: 6px !important;\n}\n\n.ml-7px {\n  margin-left: 7px !important;\n}\n\n.ml-8px {\n  margin-left: 8px !important;\n}\n\n.ml-9px {\n  margin-left: 9px !important;\n}\n\n.ml-10px {\n  margin-left: 10px !important;\n}\n\n.ml-11px {\n  margin-left: 11px !important;\n}\n\n.ml-12px {\n  margin-left: 12px !important;\n}\n\n.ml-13px {\n  margin-left: 13px !important;\n}\n\n.ml-14px {\n  margin-left: 14px !important;\n}\n\n.ml-15px {\n  margin-left: 15px !important;\n}\n\n.ml-16px {\n  margin-left: 16px !important;\n}\n\n.ml-17px {\n  margin-left: 17px !important;\n}\n\n.ml-18px {\n  margin-left: 18px !important;\n}\n\n.ml-19px {\n  margin-left: 19px !important;\n}\n\n.ml-20px {\n  margin-left: 20px !important;\n}\n\n.ml-21px {\n  margin-left: 21px !important;\n}\n\n.ml-22px {\n  margin-left: 22px !important;\n}\n\n.ml-23px {\n  margin-left: 23px !important;\n}\n\n.ml-24px {\n  margin-left: 24px !important;\n}\n\n.ml-25px {\n  margin-left: 25px !important;\n}\n\n.ml-26px {\n  margin-left: 26px !important;\n}\n\n.ml-27px {\n  margin-left: 27px !important;\n}\n\n.ml-28px {\n  margin-left: 28px !important;\n}\n\n.ml-29px {\n  margin-left: 29px !important;\n}\n\n.ml-30px {\n  margin-left: 30px !important;\n}\n\n.mr-5px {\n  margin-right: 5px !important;\n}\n\n.mr-6px {\n  margin-right: 6px !important;\n}\n\n.mr-7px {\n  margin-right: 7px !important;\n}\n\n.ml-8px {\n  margin-right: 8px !important;\n}\n\n.mr-9px {\n  margin-right: 9px !important;\n}\n\n.mr-10px {\n  margin-right: 10px !important;\n}\n\n.mr-11px {\n  margin-right: 11px !important;\n}\n\n.mr-12px {\n  margin-right: 12px !important;\n}\n\n.mr-13px {\n  margin-right: 13px !important;\n}\n\n.mr-14px {\n  margin-right: 14px !important;\n}\n\n.mr-15px {\n  margin-right: 15px !important;\n}\n\n.mr-16px {\n  margin-right: 16px !important;\n}\n\n.mr-17px {\n  margin-right: 17px !important;\n}\n\n.mr-18px {\n  margin-right: 18px !important;\n}\n\n.mr-19px {\n  margin-right: 19px !important;\n}\n\n.mr-20px {\n  margin-right: 20px !important;\n}\n\n.mr-21px {\n  margin-right: 21px !important;\n}\n\n.mr-22px {\n  margin-right: 22px !important;\n}\n\n.mr-23px {\n  margin-right: 23px !important;\n}\n\n.mr-24px {\n  margin-right: 24px !important;\n}\n\n.mr-25px {\n  margin-right: 25px !important;\n}\n\n.mr-26px {\n  margin-right: 26px !important;\n}\n\n.mr-27px {\n  margin-right: 27px !important;\n}\n\n.mr-28px {\n  margin-right: 28px !important;\n}\n\n.mr-29px {\n  margin-right: 29px !important;\n}\n\n.mr-30px {\n  margin-right: 30px !important;\n}\n\n.pr-5px {\n  padding-right: 5px;\n}\n\n.pr-6px {\n  padding-right: 6px;\n}\n\n.pr-7px {\n  padding-right: 7px;\n}\n\n.pr-8px {\n  padding-right: 8px;\n}\n\n.pr-9px {\n  padding-right: 9px;\n}\n\n.pr-10px {\n  padding-right: 10px;\n}\n\n.pr-11px {\n  padding-right: 11px;\n}\n\n.pr-12px {\n  padding-right: 12px;\n}\n\n.pr-13px {\n  padding-right: 13px;\n}\n\n.pr-14px {\n  padding-right: 14px;\n}\n\n.pr-15px {\n  padding-right: 15px;\n}\n\n.pr-16px {\n  padding-right: 16px;\n}\n\n.pr-17px {\n  padding-right: 17px;\n}\n\n.pr-18px {\n  padding-right: 18px;\n}\n\n.pr-19px {\n  padding-right: 19px;\n}\n\n.pr-20px {\n  padding-right: 20px;\n}\n\n.pr-21px {\n  padding-right: 21px;\n}\n\n.pr-22px {\n  padding-right: 22px;\n}\n\n.pr-23px {\n  padding-right: 23px;\n}\n\n.pr-24px {\n  padding-right: 24px;\n}\n\n.pr-25px {\n  padding-right: 25px;\n}\n\n.pr-26px {\n  padding-right: 26px;\n}\n\n.pr-27px {\n  padding-right: 27px;\n}\n\n.pr-28px {\n  padding-right: 28px;\n}\n\n.pr-29px {\n  padding-right: 29px;\n}\n\n.pr-30px {\n  padding-right: 30px;\n}\n\n.pr-35px {\n  padding-right: 35px;\n}\n\n.pr-40px {\n  padding-right: 40px;\n}\n\n.pr-45px {\n  padding-right: 45px;\n}\n\n.pr-50px {\n  padding-right: 50px;\n}\n\n.pr-55px {\n  padding-right: 55px;\n}\n\n.pr-60px {\n  padding-right: 60px;\n}\n\n.pl-5px {\n  padding-left: 5px;\n}\n\n.pl-6px {\n  padding-left: 6px;\n}\n\n.pl-7px {\n  padding-left: 7px;\n}\n\n.pl-8px {\n  padding-left: 8px;\n}\n\n.pl-9px {\n  padding-left: 9px;\n}\n\n.pl-10px {\n  padding-left: 10px;\n}\n\n.pl-11px {\n  padding-left: 11px;\n}\n\n.pl-12px {\n  padding-left: 12px;\n}\n\n.pl-13px {\n  padding-left: 13px;\n}\n\n.pl-14px {\n  padding-left: 14px;\n}\n\n.pl-15px {\n  padding-left: 15px;\n}\n\n.pl-16px {\n  padding-left: 16px;\n}\n\n.pl-17px {\n  padding-left: 17px;\n}\n\n.pl-18px {\n  padding-left: 18px;\n}\n\n.pl-19px {\n  padding-left: 19px;\n}\n\n.pl-20px {\n  padding-left: 20px;\n}\n\n.pl-21px {\n  padding-left: 21px;\n}\n\n.pl-22px {\n  padding-left: 22px;\n}\n\n.pl-23px {\n  padding-left: 23px;\n}\n\n.pl-24px {\n  padding-left: 24px;\n}\n\n.pl-25px {\n  padding-left: 25px;\n}\n\n.pl-26px {\n  padding-left: 26px;\n}\n\n.pl-27px {\n  padding-left: 27px;\n}\n\n.pl-28px {\n  padding-left: 28px;\n}\n\n.pl-29px {\n  padding-left: 29px;\n}\n\n.pl-30px {\n  padding-left: 30px;\n}\n\n.pl-35px {\n  padding-left: 35px;\n}\n\n.pl-40px {\n  padding-left: 40px;\n}\n\n.pl-45px {\n  padding-left: 45px;\n}\n\n.pl-50px {\n  padding-left: 50px;\n}\n\n.pl-55px {\n  padding-left: 55px;\n}\n\n.pl-60px {\n  padding-left: 60px;\n}\n\n.right-5px {\n  right: 5px;\n}\n\n.right-6px {\n  right: 6px;\n}\n\n.right-7px {\n  right: 7px;\n}\n\n.right-8px {\n  right: 8px;\n}\n\n.right-9px {\n  right: 9px;\n}\n\n.right-10px {\n  right: 10px;\n}\n\n.right-11px {\n  right: 11px;\n}\n\n.right-12px {\n  right: 12px;\n}\n\n.right-13px {\n  right: 13px;\n}\n\n.right-14px {\n  right: 14px;\n}\n\n.right-15px {\n  right: 15px;\n}\n\n.right-16px {\n  right: 16px;\n}\n\n.right-17px {\n  right: 17px;\n}\n\n.right-18px {\n  right: 18px;\n}\n\n.right-19px {\n  right: 19px;\n}\n\n.right-20px {\n  right: 20px;\n}\n\n.right-21px {\n  right: 21px;\n}\n\n.right-22px {\n  right: 22px;\n}\n\n.right-23px {\n  right: 23px;\n}\n\n.right-24px {\n  right: 24px;\n}\n\n.right-25px {\n  right: 25px;\n}\n\n.right-26px {\n  right: 27px;\n}\n\n.right-28px {\n  right: 28px;\n}\n\n.right-29px {\n  right: 29px;\n}\n\n.right-30px {\n  right: 30px;\n}\n\n/* LeftSidebarNav */\n.white-logo {\n  display: none;\n}\n\n.sidebarLinkActive {\n  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\n}\n\n.sidebarLinkActive2 {\n  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\n}\n\n.sidebarLinkActive2::before {\n  background-color: #fff !important;\n}\n\n.sidebarLinkActive2 {\n  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\n  color:#fff!important;\n}\n\n/* Main wrapper content */\n.main-wrapper-content {\n  padding-left: 330px;\n  position: relative;\n  transition: all 0.5s ease-out;\n  background-color: var(--themeColorLighterShade);\n}\n.main-wrapper-content.active {\n  padding-left: 0;\n}\n.main-wrapper-content.active .LeftSidebarNav {\n  left: -100%;\n}\n.main-wrapper-content.active .main-content {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.main-wrapper-content .main-content {\n  padding-right: 30px;\n}\n\n@media only screen and (max-width: 767px) {\n  .main-wrapper-content .main-content {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  .main-wrapper-content {\n    padding: 0;\n  }\n  .main-wrapper-content .LeftSidebarNav {\n    left: -100%;\n    width: 280px;\n  }\n  .main-wrapper-content .main-content {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .main-wrapper-content.active .LeftSidebarNav {\n    z-index: 99999;\n    left: 0;\n  }\n}\n@media only screen and (min-width: 2200px) {\n  .main-wrapper-content .main-content {\n    max-width: 2200px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n/* End Main wrapper content */\n/* React Tabs Tab List */\n.react-tabs__tab-list .react-tabs__tab--selected {\n  background-color: var(--primaryColor);\n  color: #fff;\n}\n\n/* End React Tabs Tab List */\n/* Read Email */\n.readEmail {\n  color: var(--bodyTextColor);\n  text-decoration: none;\n}\n\n.readEmail:hover {\n  color: #260944;\n}\n\n/* Product Details Tabs */\n.product-img-slider .swiper-button-next:after, .product-img-slider .swiper-button-prev:after {\n  color: var(--primaryColor);\n  font-size: 25px;\n}\n\n.product-details-tabs .react-tabs__tab-list {\n  border-bottom: 1px solid #dfdfdf;\n}\n.product-details-tabs .react-tabs__tab-list .react-tabs__tab {\n  color: #A9A9C8;\n  font-weight: 500;\n  font-size: 15px;\n  padding-left: 0;\n  padding-right: 0;\n  margin-right: 30px;\n  border-top: none;\n  border-right: none;\n  border-left: none;\n  border-bottom: 2px solid transparent;\n}\n.product-details-tabs .react-tabs__tab-list .react-tabs__tab:last-child {\n  margin-right: 0;\n}\n.product-details-tabs .react-tabs__tab-list .react-tabs__tab:hover, .product-details-tabs .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {\n  background-color: transparent;\n  border-top: none;\n  border-right: none;\n  border-left: none;\n  /* border-bottom: 2px solid var(--primaryColor); */\n  color:var(--themeFontColor);\n}\n.product-details-tabs .react-tabs__tab-list .react-tabs__tab:focus:after {\n  background: transparent;\n}\n.product-details-tabs .react-tabs__tab-panel {\n  margin-top: 20px;\n}\n.product-details-tabs .product-description h1 {\n  font-size: 22px;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.product-details-tabs .product-description h2 {\n  font-size: 20px;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.product-details-tabs .product-description h3 {\n  font-size: 18px;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.product-details-tabs .product-description h4 {\n  font-size: 16px;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.product-details-tabs .product-description h5 {\n  font-size: 15px;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.product-details-tabs .product-description h6 {\n  font-size: 14px;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.product-details-tabs .product-description p:last-child {\n  margin-bottom: 0;\n}\n.product-details-tabs .product-description ul li, .product-details-tabs .product-description ol li {\n  margin-bottom: 10px;\n}\n.product-details-tabs .product-description ul li:last-child, .product-details-tabs .product-description ol li:last-child {\n  margin-bottom: 0;\n}\n.product-details-tabs .review-card .content {\n  background: #F7FAFF;\n  border-radius: 8px;\n  position: relative;\n  padding: 25px;\n  margin-bottom: 30px;\n}\n.product-details-tabs .review-card .content .reating {\n  color: #FFBC2B;\n  margin-bottom: 10px;\n  font-size: 15px;\n}\n.product-details-tabs .review-card .content .reating i {\n  margin-right: 5px;\n}\n.product-details-tabs .review-card .content .reating i:last-child {\n  margin-right: 0;\n}\n.product-details-tabs .review-card .content p {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.product-details-tabs .review-card .content p:last-child {\n  margin-bottom: 0;\n}\n.product-details-tabs .review-card .content .down-arrow {\n  position: absolute;\n  bottom: -20px;\n  left: 25px;\n}\n.product-details-tabs .review-card .info {\n  display: flex;\n  align-items: center;\n  margin-left: 30px;\n}\n.product-details-tabs .review-card .info img {\n  border-radius: 100%;\n  width: 30px;\n  height: 30px;\n  margin-right: 10px;\n}\n.product-details-tabs .review-card .info h4 {\n  margin: 0;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n/* For dark mode */\n[class=dark] .product-details-tabs .react-tabs__tab-list {\n  border-bottom: 1px solid var(--borderColor);\n}\n[class=dark] .product-details-tabs .react-tabs__tab-list .react-tabs__tab:hover, [class=dark] .product-details-tabs .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {\n  color: var(--primaryColor);\n}\n\n[dir=rtl] .product-details-tabs .react-tabs__tab-list .react-tabs__tab {\n  margin-right: 0;\n  margin-left: 30px;\n}\n[dir=rtl] .product-details-tabs .react-tabs__tab-list .react-tabs__tab:last-child {\n  margin-left: 0;\n}\n[dir=rtl] .product-details-tabs .review-card .content .reating i {\n  margin-right: 0;\n  margin-left: 5px;\n}\n[dir=rtl] .product-details-tabs .review-card .content .reating i:last-child {\n  margin-left: 0;\n}\n[dir=rtl] .product-details-tabs .review-card .content .down-arrow {\n  left: auto;\n  right: 25px;\n}\n[dir=rtl] .product-details-tabs .review-card .info {\n  margin-left: auto;\n  margin-right: 30px;\n}\n[dir=rtl] .product-details-tabs .review-card .info img {\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n/* Testimonial Style */\n.testimonialStyle1 .swiper-button-next, .testimonialStyle1 .swiper-button-prev, .testimonialStyle2 .swiper-button-next, .testimonialStyle2 .swiper-button-prev {\n  color: var(--primaryColor);\n}\n.testimonialStyle1 .swiper-button-next::after, .testimonialStyle1 .swiper-button-prev::after, .testimonialStyle2 .swiper-button-next::after, .testimonialStyle2 .swiper-button-prev::after {\n  font-size: 25px;\n}\n.testimonialStyle1 .swiper-button-next, .testimonialStyle2 .swiper-button-next {\n  right: 0;\n}\n.testimonialStyle1 .swiper-button-prev, .testimonialStyle2 .swiper-button-prev {\n  left: 0;\n}\n\n[dir=rtl] .testimonialStyle1 .swiper-button-next, [dir=rtl] .testimonialStyle2 .swiper-button-next {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .testimonialStyle1 .swiper-button-prev, [dir=rtl] .testimonialStyle2 .swiper-button-prev {\n  left: auto;\n  right: 0;\n}\n\n.testimonialStyle3 .swiper-pagination {\n  position: relative;\n}\n.testimonialStyle3 .swiper-pagination .swiper-pagination-bullet {\n  width: 10px;\n  height: 10px;\n}\n.testimonialStyle3 .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: var(--primaryColor);\n}\n\n/* Active File Manager Link */\n.activeFMLink > a {\n  color: var(--primaryColor) !important;\n}\n\n.fc .fc-toolbar-title {\n  font-size: 20px !important;\n}\n\n/* Authentication box */\n.main-wrapper-content:has(div.authenticationBox) {\n  padding: 0;\n}\n\n/* End Authentication box */\n.apexcharts-yaxis text, .apexcharts-xaxis text {\n  /* fill: var(--bodyTextColor); */\n  fill:#e55e08;\n\n}\n\n.scroll-to-top i {\n  position: fixed;\n  cursor: pointer;\n  bottom: 20px;\n  right: 20px;\n  color: #fff !important;\n  background-color: var(--primaryColor);\n  width: 40px;\n  text-align: center;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 50%;\n  font-size: 20px;\n  transition: var(--transition);\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1290;\n}\n.scroll-to-top i:hover {\n  transition: var(--transition);\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n  transform: translateY(-5px);\n}\n\n.control-panel-modal {\n  position: fixed;\n  right: -100%;\n  top: 0;\n  z-index: 999999;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.2);\n  transition: var(--transition);\n}\n.control-panel-modal.show {\n  right: 0;\n}\n.control-panel-modal .settings-btn {\n  position: fixed;\n  bottom: 70px;\n  right: 15px;\n  background-color: var(--dangerColor);\n  color: #fff;\n  z-index: 1290;\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  line-height: 50px;\n  border-radius: 100%;\n  font-size: 25px;\n  cursor: pointer;\n  transition: var(--transition);\n  animation: rotate 2s linear infinite;\n}\n.control-panel-modal .settings-btn:hover {\n  background-color: #d32979;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.control-panel-dialog {\n  width: 320px;\n  background: #fff;\n  height: 100%;\n  margin-left: auto;\n  z-index: 999999;\n  position: relative;\n}\n.control-panel-dialog .control-panel-content {\n  overflow-y: auto;\n  height: 100%;\n  padding-bottom: 150px;\n}\n.control-panel-dialog .control-panel-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background-color: #F5F5F5;\n  padding: 16px 24px;\n  width: 100%;\n}/*# sourceMappingURL=globals.css.map */\n\n.css-1knvo2r-MuiPaper-root-MuiCard-root{\n  border: 1px solid #363535;\n}\n\n/* dark mode */\n.apexcharts-legend-text{\n   color:#ff87ef;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
